export default [{
  path: '/admin/apply/rights/package',
  name: 'rightsPackage',
  component: () => import('@/views/apply/rights/package'),
  meta: {
    title: '权益套餐管理',
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/rights/detail',
  name: 'rightsDetail',
  component: () => import('@/views/apply/rights/detail'),
  meta: {
    title: '权益明细管理',
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/rights/config',
  name: 'rightsConfig',
  component: () => import('@/views/apply/rights/config'),
  meta: {
    title: '权益配置',
    headType: 0,
    auth: true
  }
}]



// WEBPACK FOOTER //
// ./src/router/apply/rights.js